module.exports = __webpack_public_path__ + "img/mg.cd704bc7.svg";